import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { TokenService } from '../services/token.service';
import { environment } from 'src/environments/environment';
import { RoutingService } from '../services/routing.service';
import { EventInteractionService } from '@mare-common/ngx-mare-common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnDestroy, OnInit {
  sub: any;
  accessToken: any;
  isReset: any;

  constructor(
    private authService: MareAuthService,
    public router: Router,
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private routingService: RoutingService,
    private eventInteractionService: EventInteractionService
  ){

  }

  ngOnInit(){
    this.sub = this.tokenService.isInit$.subscribe((isInit) => {
      if(isInit) {
        this._ngOnInit();
      }
    })
    
  }
  _ngOnInit(){
    if (this.authService.isLogged()) {
      this.routingService.routingNavigate('/' + environment.routingBasePath+'/'+environment.routingLoginRedirect, true)
      // this.router.navigate(['/' + environment.routingBasePath+'/'+environment.routingLoginRedirect]);
    } else {

      this.isReset = this.route.snapshot.queryParams['reset'];
      if (this.isReset && this.isReset == 'true') {
        window.location.href = environment.oauthConfig.oauthIssuer + '/login-actions/reset-credentials?client_id=web';
        return;
      }

      this.accessToken = this.route.snapshot.queryParams['access_token'];
      let params: any | undefined;
      if (this.accessToken) {
        params = {
          'access_token': this.accessToken
        }
      }
      let delfiToken = this.route.snapshot.queryParams['delfi_token'];
      if (delfiToken) {
        params = {
          'delfi_token': delfiToken
        }
      }
      let redirect_uri = this.route.snapshot.queryParams['redirect_uri'];
      if (redirect_uri) {
        if(!params) {
          params = {};
        }
        params.redirect_uri = redirect_uri;
        } else {
          if(this.routingService.getRedirect()) {
            redirect_uri = this.routingService.getRedirect();
            if(!params) {
              params = {};
            }
            params.redirect_uri = '' + redirect_uri;
            this.routingService.registerRedirect(null);
          }
        }
      let p: object | undefined = params;
      this.authService.start(p);
    }
  }

  ngOnDestroy() {
    if(this.sub)
      this.sub.unsubscribe();
  }
  goToSign() {
    this.accessToken = this.route.snapshot.queryParams['access_token'];
      let params: object | undefined;
      if (this.accessToken) {
        params = {
          'access_token': this.accessToken
        }
      }
      this.authService.start(params);
  }
}
